module.exports = __webpack_public_path__ + "media/Diagnose Clarissa_neu.e2c84ef1.mp4";